<div [ngClass]="responsiveService.getBigSmall()" class="component-container">
    <form [formGroup]="enterRoomForm" (ngSubmit)="enterRoom(enterRoomForm.value)" autocomplete="off" novalidate>
        <mat-form-field appearance="outline" class="enter-room-field">
            <input matInput placeholder="Enter Room Number" [formControl]="roomId">
        </mat-form-field>

        <button mat-flat-button color="primary" i18n class="spo-font-color-white enter-room-button">ENTER</button>
    </form>
</div>